import { defineComponent as _defineComponent } from 'vue'
import { Button as ElButton } from 'element-ui';
import { ref } from 'vue';
import { sleep } from '@/js/lib/helper/sleep';


export default /*#__PURE__*/_defineComponent({
  __name: 'IButton',
  props: {
    type: { default: 'secondary' },
    size: { default: '' },
    href: { default: '' },
    flexible: { type: Boolean },
    center: { type: Boolean }
  },
  setup(__props: any, { expose }) {


const isShowRipple = ref(false);
const buttonEl = ref();
const showRipple = async () => {
  isShowRipple.value = true;
  await sleep(100);
  isShowRipple.value = false;
};

expose({
  focus: async () => {
    await sleep(100);
    buttonEl.value.$el.focus();
  },
});

return { __sfc: true,isShowRipple, buttonEl, showRipple, ElButton }
}

})